module.exports = __webpack_public_path__ + "static/trainagg-screen-8ad522e9e0ee2e616369cd84686ac0f9.jpg";